module.exports = __webpack_public_path__ + "img/laptop.0c893436.svg";